export abstract class JobActionCodeConstants {
  static readonly RESUME_REQUIRED = '-2';
  static readonly SKILL_DOCUMENT_REQUIRED = '-1';
  static readonly QUESTIONNAIRE_REQUIRED = '02';
  static readonly TIMESLOT_REQUIRED = '-0';
  static readonly RESUME = 'RESUME';
  static readonly QUESTIONNARE = 'QUESTIONNARE';
  static readonly RESUME_UPLOAD_NOT_REQUIRED = '00';
  static readonly RESUME_UPLOAD_MANDATORY = '01';
  static readonly RESUME_UPLOAD_OPTIONAL = '02';
  static readonly RESUME_UPLOAD_NOT_REQUIRED_OPTIONAL = '0';
  static readonly RESUME_UPLOAD_MANDATORY_OPTIONAL = '1';
  static readonly RESUME_UPLOAD_OPTIONAL_OPTIONAL = '2';

} 